import { render, staticRenderFns } from "./Purposes.vue?vue&type=template&id=497cc185"
import script from "./Purposes.vue?vue&type=script&lang=js"
export * from "./Purposes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports